import { render } from "./MGTestView.vue?vue&type=template&id=e3a51caa&scoped=true"
import script from "./MGTestView.vue?vue&type=script&lang=js"
export * from "./MGTestView.vue?vue&type=script&lang=js"

import "./MGTestView.vue?vue&type=style&index=0&id=e3a51caa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a51caa"]])

export default __exports__